{
  "title": "Kinetic Jaunt",
  "source": "Strixhaven: A Curriculum of Chaos",
  "levelAndSchool": "2nd-level Transmutation",
  "level": 2,
  "castingTime": "1 bonus action",
  "range": "Self",
  "components": "S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You magically empower your movement with dancelike steps, giving yourself the following benefits for the duration:",
    "Your walking speed increases by 10 feet.",
    "You don't provoke opportunity attacks.",
    "You can move through the space of another creature, and it doesn't count as difficult terrain. If you end your turn in another creature's space, you are shunted to the last unoccupied space you occupied, and you take 1d8 force damage."
  ],
  "spellLists": ["artificer", "bard", "sorcerer", "wizard"]
}
